module.exports = __webpack_public_path__ + "static/media/light_dataak_fav.f84d8c0b.png";